import React, { useRef } from 'react';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  base: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  ratingField: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    border: 'none',
    gap: '0.25rem',
    '& button': {
      cursor: 'pointer',
      width: '1.6rem',
      height: '2.5rem',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      display: 'block',
      border: 'none',
      backgroundColor: '#ddd',
      transition: 'all 0.3s ease-in-out',
      borderRadius: '5px',
      color: '#7f7f7f',
    },
    '& .active': {
      color: '#fff',
      backgroundColor: '#ea1917',
    },
  },
});

const NpsRating = (props) => {
  const { classes, handleStarButtonClick, btnActive } = props;
  const buttonRef = useRef([]);
  const numArr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  return (
    <div className={classes.base}>
      <div className={classes.ratingField}>
        {numArr.map((idx, i) => {
          return (
            <button
              name="rating"
              id={`NPS_${idx}`}
              key={idx}
              value={idx}
              onClick={(e) => {
                handleStarButtonClick(e.target.value);
              }}
              ref={(el) => (buttonRef.current[idx] = el)}
              className={idx === btnActive ? 'active' : ''}
              title={idx === btnActive ? '선택됨' : ''}
            >
              {idx}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default withStyles(styles)(NpsRating);
